import { useEffect, useState } from "react";
import LoginOne from "../ProfileUser/Login/LoginOne";
import LoginTwo from "../ProfileUser/Login/LoginTow";
import LoginThreeOtp from "../ProfileUser/Login/LoginThreeOtp";
import { useNavigate } from "react-router-dom";

const Login = () => {

    const navigate = useNavigate(); 
    useEffect(() => {
        const token = localStorage.getItem("userToken");
        if (token) {
            navigate("/dashboard"); // Redirect to dashboard if token exists
        }
    }, [navigate]);
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        otp: "",
        phone: "",
    });

    console.log("FormData:", formData); // To verify `phone` and `otp`

    const nextStep = () => {
        setStep(step + 1);
    };

    const prevStep = () => {
        setStep(step - 1);
    };

    const handleInputData = (input) => (e) => {
        const { value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [input]: value,
        }));
    };

    
    switch (step) {
        case 1:
            return (
                <div className="flex items-center justify-center bg-[#F2F2F2] h-[100vh]">
                    <LoginOne
                        nextStep={nextStep}
                        handleFormData={handleInputData}
                        values={formData}
                    />
                </div>
            );
        case 2:
            return (
                <div className="flex items-center justify-center bg-[#F2F2F2] h-[100vh]">
                    <LoginTwo
                        nextStep={nextStep}
                        prevStep={prevStep}
                        handleFormData={handleInputData}
                        values={formData}
                    />
                </div>
            );
        case 3:
            return (
                <div className="flex items-center justify-center bg-[#F2F2F2] h-[100vh]">
                    <LoginThreeOtp
                        nextStep={nextStep}
                        prevStep={prevStep}
                        handleFormData={handleInputData}
                        values={formData}
                    />
                </div>
            );
        default:
            return (
                <div className="flex justify-center items-center min-h-screen bg-gray-100">
                    Invalid Step
                </div>
            );
    }
};

export default Login;
